module.exports = __webpack_public_path__ + "img/Xzqy.84e8d345.svg";